<template>
  <span class="menu-new-badge">{{ label }}</span>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  label?: string;
}>(), {
  label: 'NEW',
});
</script>

<style scoped lang="scss">
.menu-new-badge {
  flex-shrink: 0;
  padding: 4px;
  border-radius: 4px;
  background: $color-purple;
  color: $color-on-accent;
  font-size: 8px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.02em;
}
</style>
